import getDefaultStartDate from 'helpers/dateHelpers';
import { FilterChipItem } from 'components/ui/FilterChipCarousel/FilterChipCarousel';
import { FilterPreset, FilterSetters, LocationData } from './types';
import { GeoBoundaries } from '../GeoBoundaries';

// Pure utility functions
export const getLocationName = (locationData: LocationData): string => {
  const { DSUQueryName, near, area } = locationData;
  const areaName = GeoBoundaries.find((boundary) => boundary.Area === area)?.AreaName;
  return areaName || near || DSUQueryName;
};

export const normalizeString = (str: string): string => {
  const lowerCased = str?.toLowerCase().trim();
  return lowerCased;
};

export const mapPresetsToChipItems = (presets: FilterPreset[], selectedPresetId: string): FilterChipItem[] =>
  presets?.map((preset, index) => ({
    id: preset.id,
    label: preset.label,
    value: preset,
    selected: preset.id === selectedPresetId,
    position: index + 1,
  }));

// Filter application functions
export const applyBoatCategories = (setters: FilterSetters, categories: any): void => {
  setters.setBoatCategories(categories);
};

export const applyCaptainOption = (setters: FilterSetters, option: string): void => {
  setters.setCaptainOption(option);
};

export const applyPriceRange = (setters: FilterSetters, range: [number, number]): void => {
  const [min, max] = range;
  setters.setPriceRange({ value: min });
  setters.setPriceRange({ value: max, isMaxValue: true });
};

export const applyLengthRange = (setters: FilterSetters, range: [number, number?]): void => {
  const [min, max] = range;
  setters.setLengthRange({ value: min });

  if (max !== undefined) {
    setters.setLengthRange({ value: max, isMaxValue: true });
  }
};

export const applyAmenities = (setters: FilterSetters, amenities: any): void => {
  setters.setAmenities(amenities);
};

export const applyPassengers = (setters: FilterSetters, count: number): void => {
  setters.setPassengers(count);
};

export const applyActivities = (setters: FilterSetters, activities: any): void => {
  setters.setActivities(activities);
};

export const applyInstantBook = (setters: FilterSetters, value: boolean): void => {
  setters.setInstantBook(value);
};

export const applyWeekendAvailable = (setters: FilterSetters): void => {
  const defaultDate = getDefaultStartDate();
  const formattedDefaultDate = defaultDate.toISOString().split('T')[0];
  setters.setTripStartAtom(defaultDate);
  setters.setDateAtom(formattedDefaultDate);
};

export const applyAllFilters = (setters: FilterSetters, filters: FilterPreset['filters']): void => {
  if (filters.boatCategories) applyBoatCategories(setters, filters.boatCategories);
  if (filters.priceRange) applyPriceRange(setters, filters.priceRange);
  if (filters.lengthRange) applyLengthRange(setters, filters.lengthRange);
  if (filters.captainOption) applyCaptainOption(setters, filters.captainOption);
  if (filters.amenities) applyAmenities(setters, filters.amenities);
  if (filters.passengers) applyPassengers(setters, filters.passengers);
  if (filters.activities) applyActivities(setters, filters.activities);
  if (filters.instantBook !== undefined) applyInstantBook(setters, filters.instantBook);
  if (filters.weekendAvailable !== undefined) applyWeekendAvailable(setters);
};
